module.exports = __webpack_public_path__ + "img/green-2-squiggly-open.7d6115ad.svg";